import request from '@/utils/request'

export function getPptEntitlement() {
  return request.get('/ppt/entitlement')
}

export function uploadPptFile(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/ppt/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000
  })
}

export function deletePptUpload(uploadId) {
  return request.delete(`/ppt/upload/${uploadId}`)
}

export function getPptTemplateOptions() {
  return request.get('/ppt/template-options')
}

export function getPptTemplates(params) {
  return request.get('/ppt/templates', { params })
}

export function submitPpt(data) {
  return request.post('/ppt/submit', data)
}

export function getPptTasks(params) {
  return request.get('/ppt/tasks', { params })
}

export function getPptTaskDetail(taskNo) {
  return request.get(`/ppt/task/${taskNo}/detail`)
}

export function getPptDownloadUrl(taskNo) {
  return request.get(`/ppt/task/${taskNo}/download-url`)
}

export function deletePptRecord(taskNo) {
  return request.delete(`/ppt/tasks/${taskNo}`)
}
